module.exports = __webpack_public_path__ + "img/ASC_SORT.6c5ec2fc.svg";